'use client';

import CommonDataProvider, { type Data as CommonDataType } from './CommonDataProvider';
import { DataLiveProvider } from './DataLiveProvider';

export function Providers({
  children,
  value,
}: {
  children: React.ReactNode;
  value: CommonDataType;
}) {
  return (
    <CommonDataProvider value={value}>
      <DataLiveProvider>{children}</DataLiveProvider>
    </CommonDataProvider>
  );
}
